/**
 * Escape text for safe insertion into HTML (e.g. SweetAlert `html`).
 *
 * @param {unknown} value
 * @returns {string}
 */
export function escapeHtml(value) {
	if (value == null) {
		return "";
	}
	return String(value)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}
